import React, { useContext } from "react";
import SupplierContext from "../../../contexts/SupplierContext";
import VendorContext from "../../../contexts/VendorContext";
import OwLabel from "../../shared/OwLabel/OwLabel";
import styled from "styled-components";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";

type Props = {
    removeWidget?: () => void;
    inEditor?: boolean;
};

export const FreightPolicyWidget = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);

    const freightPolicy = vendorModel.freight_policy || supplierModel.default_freight_policy;

    return (
        <WidgetContainer className={"FreightPolicyWidget widget"}>
            {props.inEditor ? (
                <div className={""}>
                    <OwIconButton iconClass={"fas fa-trash-alt"} iconColorClass={"text-danger"} fn={props.removeWidget!} />
                </div>
            ) : null}
            <div className={"text-warning"}>
                <OwLabel title={"freight_policy"} postText={":"} className={"me-1"} />
                <div>
                    {freightPolicy ? (
                        <OwLabel skipTranslate={true} leftIconClass={""} title={freightPolicy} />
                    ) : (
                        <OwLabel title={"freight_policy_not_set"} />
                    )}
                </div>
            </div>
        </WidgetContainer>
    );
};

const WidgetContainer = styled.div`
    padding: 0.5rem;
    justify-content: start !important;
    align-items: start !important;
    height: 100%;

    input {
        width: 100%;
    }

    .position-relative {
        width: 100%;
    }
`;
